import React from 'react';
import ReactDOM from 'react-dom/client'; // Usa 'react-dom/client' en lugar de 'react-dom'
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
